module.exports = __webpack_public_path__ + "static/img/2.024d4bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/2.png
// module id = +iRU
// module chunks = 1